<template>
  <target-form-styles class="appending_file_uploader__form">
    <div class="appending_file_uploader__header">
      Choose a target to append a file to
    </div>
    <upload-target-radio-buttons
      class="appending_file_uploader__target-selection"
      v-model="targetTypeSelected"
      :on-select="selectTargetType"
    />
    <v-row justify="space-around">
      <v-col md="6">
        <target-d-d-l
          ref="targetDDL"
          :targetType="targetType"
          v-model="target"
          :initialValue="target"
        />
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col md="4" class="d-flex justify-center align-center">
        <v-file-input
          v-if="isPid"
          :accept="uploadFileOptions"
          ref="fileUploadInput"
          :disabled="isUploadDisabled"
          @change="onFileChange"
          v-model="uploadedFile"
          placeholder="No file chosen"
          prepend-icon="mdi-microsoft-excel"
        >
        </v-file-input>
      </v-col>
      <v-col md="4" class="d-flex justify-center align-center">
        <action-button :disabled="!buttonClickable" color="secondary" id="appendFileModalUploadBtn" label="upload" @click.native="submitHandler" />
      </v-col>
    </v-row>
  </target-form-styles>
</template>

<script>
import UploadTargetRadioButtons from '../components/UploadTargetRadioButtons'
import TargetDDL from '@/appComponents/targets/components/TargetDDL'
import ActionButton from '@/components/common/actionButton'
import TargetFormStyles from './TargetFormStyles'
import {TARGET_TYPE} from '@/appLogic/targets/Constants'
import {convertTargetToTargetType} from '@/appLogic/targets/conversions'
import {
  UPLOAD_TARGET_FILE,
  UPLOAD_MODAL_SET_APPEND_TYPE
} from '@/appLogic/targets/createTarget/store/actions'
import {SET_SHOW_APPEND_MODAL} from '@/appLogic/targets/currentTarget/store/actions'
import {validatePidFile} from '@/appLogic/targets/pid/PidLogic'
import Toast from '@/components/common/toasts'

export default {
  components: {
    UploadTargetRadioButtons,
    TargetDDL,
    ActionButton,
    TargetFormStyles
  },
  props: {
    defaultAppendOption: {
      type: String,
      default: null
    },
    defaultSelectedTarget: {
      type: Object,
      default: null
    },
    onCompleteUpload: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      target: null,
      targetTypeSelected: TARGET_TYPE.PID,
      uploadFileOptions: '.csv',
      selectedFiles: null,
      uploadedFile: [],
    }
  },
  computed: {
    targetType () {
      return convertTargetToTargetType(this.targetTypeSelected)
    },
    buttonClickable () {
      if (this.targetTypeSelected === TARGET_TYPE.PID && this.selectedFiles === null) {
        return false
      }
      return this.target
    },
    buttonClass () {
      return this.buttonClickable ? 'target-form__button--active' : 'target-form__button--inactive'
    },
    isUploadDisabled () {
      return !this.targetTypeSelected
    },
    isPid () {
      return this.targetTypeSelected === TARGET_TYPE.PID
    }
  },
  methods: {
    selectTargetType () {
      if (this.targetTypeSelected === TARGET_TYPE.NPOWER || this.targetTypeSelected === TARGET_TYPE.COMSCORE) {
        this.uploadFileOptions = '.xlsx,.xls'
      } else if (this.targetTypeSelected === TARGET_TYPE.PID) {
        this.uploadFileOptions = '.csv'
      }
    },
    onFileChange (event) {
      if (event instanceof File) {
        this.selectedFiles = null
        validatePidFile(event, valid => {
          if (valid) {
            this.selectedFiles = [event]
          } else {
            Toast.error({title: 'Error has occurred', message: `Error: File has invalid values`})
          }
        })
      }
    },
    submitHandler () {
      if (this.isPid) {
        const targetInfo = {
          target: this.target,
          file: this.selectedFiles[0]
        }
        this.$store.dispatch(UPLOAD_TARGET_FILE, targetInfo).then(res => {
          if (!res.Error) {
            this.onCompleteUpload(this.target, res)
          }
        })
      } else {
        // Must be NPOWER
        this.$store.dispatch(SET_SHOW_APPEND_MODAL, {target: this.target, showModal: false})
        this.$store.dispatch(UPLOAD_MODAL_SET_APPEND_TYPE, TARGET_TYPE.NPOWER)
      }
    },
    refresh () {
      this.target = null
      this.targetTypeSelected = TARGET_TYPE.PID
      this.uploadFileOptions = '.csv'
      this.selectedFiles = null
    }
  },
  mounted () {
    this.targetTypeSelected = this.defaultAppendOption || this.targetTypeSelected
    this.target = this.defaultSelectedTarget || this.target
  },
  watch: {
    targetType () {
      this.$refs.targetDDL.clear()
      this.selectedFiles = null
    },
    defaultAppendOption () {
      this.targetTypeSelected = this.defaultAppendOption
    },
    defaultSelectedTarget () {
      this.target = this.defaultSelectedTarget
    }
  }
}
</script>

<style lang="scss">
.appending_file_uploader {
  &__form {
    margin: 0 auto;
    text-align: center;
    color: #444444;
  }

  &__header {
    margin-top: 0.667em;
    margin-bottom: 1.2em;
    color: #f44336!important;
  }

  &__file_upload {
    margin-top: 20px;
  }
  &__target-selection {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// AppendFileUploader.vue?47e4756f